import styled from "styled-components"

import { ContractorUserRole } from "types/ContractorUserEnum"

import { RoleContainer, RoleDescription, RoleHeader, RoleTitle } from "./styled"

const StyledRoleContainer = styled(RoleContainer)`
  border-bottom: none;

  > div:last-child {
    width: auto;
  }
`

interface Props {
  selectedRole: ContractorUserRole
}

const ContractorRoleSelect = ({ selectedRole }: Props) => {
  return (
    <>
      <RoleHeader>Role</RoleHeader>

      {selectedRole === ContractorUserRole.ADMIN && (
        <StyledRoleContainer>
          <div>
            <RoleTitle>Admin</RoleTitle>
            <RoleDescription>Full access</RoleDescription>
          </div>
        </StyledRoleContainer>
      )}
      {selectedRole === ContractorUserRole.MANAGER && (
        <StyledRoleContainer>
          <div>
            <RoleTitle>Manager</RoleTitle>
            <RoleDescription>Full access to all features except user management (create/edit).</RoleDescription>
          </div>
        </StyledRoleContainer>
      )}
      {selectedRole === ContractorUserRole.TECHNICIAN && (
        <StyledRoleContainer>
          <div>
            <RoleTitle>Technician</RoleTitle>
            <RoleDescription>
              Can manage customer data, run performance tests, and access device monitoring data and alerts.
            </RoleDescription>
          </div>
        </StyledRoleContainer>
      )}
    </>
  )
}

export default ContractorRoleSelect
